/** PointMesh resource slice: claims the type name. */
import { registerGenericResourceSlice } from '../../sliceRegistration.js';
registerGenericResourceSlice('pointmesh', ['PointMesh'], { declaresNoProperties: true });
//# sourceMappingURL=index.js.map